import { Box, Grid, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactChildren } from "../../interfaces/Common";
import Images from "../../Assets/assetHelper";
import KenColors from "../../Helpers/Themes/kenColors";

const useStyles = makeStyles((theme: Theme) => ({
  base: {
    margin: "1rem"
  }
}));

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} sx={{ height: '100vh' }}>
      <Grid item xs={12} sm={6} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Box
          sx={{
            backgroundImage: `url(${Images.Images.imageLogin})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '97%',
            borderBottomRightRadius: "60px",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'start',
            margin:"1rem 0rem 0rem 1rem"
          }}
        >
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {children}
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
